<app-navbar></app-navbar>

<div class="dashboard-full-width">
    <div class="">
        <div class="main-container-dashboard">

            
            <!-- <app-samplecenter-sidebar></app-samplecenter-sidebar> -->

            <div class="card shadow custom-margin-right-box" style="width: 100%">
                <div class=" card-header heading_n_button_box card-header-cus-new-appoint card-header-responsive">
                    

                

                    <div class="card-heading">
                        <h4>New Appointments</h4>
                    </div>

                    <div class="button-section mt-1">

                        <!-- Hidden button -->
                        <button type="button" class="d-none" id="viewLogSampleFormModal"
                            (click)="showModal(viewLogSampleFormModal)"></button>
                        <button type="button" class="d-none" id="viewStatusModal"
                            (click)="showModal(viewStatusModal)"></button>
                        <!-- Hidden button - End -->

                        <!-- <button class="mr-4 small-btn-dash mt-6px" (click)="showModal(addLogSampleModal)">Make Payment</button> -->

                        <!-- <button class="mr-4 small-btn-dash mt-6px" id="logSample" (click)="showModal(addLogSampleModal)">Log Sample</button> -->
                    </div>



                </div>
                <div class="card-body">

                    <div class="row">
                        


                        <div class="col-lg-12">

                            <form [formGroup]="searchForm" (ngSubmit)="onSubmitSearch(searchForm.value)">
                                <div class="row">
                                    <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                                    <!-- <div class="level-heading">Traveller Type</div> -->
                                    <select formControlName="traveller" class="form-select select-option col-lg-12" aria-label="Default select example">
                                        <option  value="">Traveller Type</option>
                                        <option value="2">Arriving Equitorial Guinea</option>
                                        <option value="1">Departing Equitorial Guinea</option>
                                    </select>
                                  </div>
                                  <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                                    <div class="form-group">
                                        <div class="input-group">
                                            <input class="form-control icon-cal font-12" type="text" formControlName="daterangeInput"
                                                placeholder="Appointment: Date From - Date To" 
                                                daterangepicker [options]="options"
                                                (selected)="selectedDate($event, daterange)"
                                                title="Appointment: Date From - Date To" />
                                        </div>
                                    </div>
                                  </div>
                                  <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                                    <input type="text" class="form-control" id="passportNumber" maxlength="15"
                                        formControlName="passportNumber"
                                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; searchForm.controls.passportNumber.errors }"
                                        placeholder="Passport Number">
                                    <div *ngIf="submitted &amp;&amp; searchForm.controls.passportNumber.errors" class="form-text text-danger">
                                         
                                        <div *ngIf="searchForm.controls.passportNumber.errors.minlength">Please enter a valid Passport number</div>
                                    </div>
                                  </div>
                                  <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                                        <input type="text" class="form-control" id="appointmentId" maxlength="11"
                                            formControlName="appointmentId"
                                            [ngClass]="{ 'is-invalid': submitted &amp;&amp; searchForm.controls.appointmentId.errors }"
                                            placeholder="Appointment ID">
                                        <div *ngIf="submitted &amp;&amp; searchForm.controls.appointmentId.errors" class="form-text text-danger">
                                              
                                            <div *ngIf="searchForm.controls.appointmentId.errors.minlength">Please enter a valid Appointment ID</div>
                                        </div>
                                  </div>
                                  <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                                    <div class="mr-4">
                                        <button class="btn btn-secondary  theme-btn-2 dropdown-toggle-no" type="submit" id="dropdownMenuButton"
                                           aria-haspopup="true" aria-expanded="false">
                                           <i class="fas fa-search"></i>  Search
                                        </button>

                                        <button class="btn btn-secondary  theme-btn-2 dropdown-toggle-no ml-2" type="button" id="dropdownMenuButton"
                                           aria-haspopup="true" aria-expanded="false" (click)="clearSearch()">
                                           <i class="fas fa-sync-alt"></i> Clear
                                        </button>
                                        
                                    </div>
                                </div>
                                </div>
                            </form>

                        </div>


                        <!-- <h3 class="dashboard-heading-1">Passenger personal Information</h3> -->
                        <div class="col-lg-12 mt-4">
                            <div class="col-auto">
                                <div class="row" *ngIf="appointments">
                                    <div class="show-record mt-3 mbm-32">
                                        <span>Show</span> &nbsp;
                                        <select class="
                                                custom-select custom-select-sm
                                                form-control form-control-sm
                                                " (change)="setItemsPerPage(page.value)" #page>
                                            <option [selected]="currentPageLength == 10">
                                                10
                                            </option>
                                            <option [selected]="currentPageLength == 30">
                                                30
                                            </option>
                                            <option [selected]="currentPageLength == 50">
                                                50
                                            </option>
                                            <option [selected]="currentPageLength == 100">
                                                100
                                            </option>
                                            <option [selected]="currentPageLength == 500">
                                                500
                                            </option>
                                            <option [selected]="currentPageLength == 1000">
                                                1000
                                            </option>
                                        </select>
                                        &nbsp;
                                        <span> entries</span>
                                    </div>
                                </div>
                            </div>
                            <div class="table table-responsive" >
                                <table
                                    class="table table-bordered table-condensed table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl nowrap"
                                    datatable [dtOptions]="dtOptions" width="100%" *ngIf="appointments;">
                                    <thead class="">
                                        <tr>
                                            <th scope="col">S/N</th>
                                            <th scope="col">Appointment ID</th>
                                            <th scope="col">Surname</th>
                                            <th scope="col">First Name</th>
                                            <th scope="col">Middle Name</th>
                                            <th scope="col">Passport Number</th>
                                            <th scope="col">Type Of Traveller</th>
                                            <th scope="col">Phone Number</th>
                                            <th scope="col">Enrollment Date</th>
                                            <th scope="col">Appointment Date & Time</th>
                                            <th scope="col">Payment Status</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody class="dashboard-bg-white">

                                        <tr *ngFor="let item of appointments | paginate: config; index as i">
                                            <th scope="row">{{config.itemsPerPage * (config.currentPage - 1) +
                                            i +
                                            1}}</th>
                                            <td>{{item.ctms_passenger_id}}</td>
                                            <td>{{item.last_name}}</td>
                                            <td>{{item.first_name}}</td>
                                            <td>{{item.middle_name ? item.middle_name : 'N/A' }}</td>
                                            <td>{{item.passport_no}}</td>
                                            <td> {{item.type == 1 ? 'DEPARTING' : 'ARRIVING' }}</td>
                                            <td>{{item.phone}}</td>
                                            <td>{{item.created_at | date}}</td>
                                            <td>{{item.booking_date + ' ' + item.booking_time | date: 'MMM, dd, yyyy, hh:mm a'}}</td>
                                            <td [ngClass]="{'text-success': item.payment_status == 1}">{{item.payment_status == 1 ? 'Paid' : 'Pending'}} </td>
                                            <td><button title="View" class="btn-view mr-3" (click)="showModalData(sampleModal, item)"><i class="far fa-eye"></i></button>
                                                
                                            <button [disabled]="item.result_submitted=='TRUE'" [ngStyle]="{'background-color': (item.result_submitted=='TRUE') ? 'gray' : ''}" title="Log Sample" class="btn-view" (click)="showModalLogSample(viewLogSampleFormModal, item.ctms_passenger_id)"><i class="fas fa-sign-in-alt"></i></button>
                                            </td>
                                        </tr>
                                        
                                    </tbody>
                                </table>
                                <div class="table-footer">
                                    <div id="page_info" class="mt-3 record-show-text-bottom" *ngIf="appointments">
                                        Showing {{(config.currentPage-1) * config.itemsPerPage + 1}} - {{config.currentPage *
                                        config.itemsPerPage}}
                                        of {{ config.totalItems }} entries
                                    </div>
                                
                                    <div class="pagination paging-pull-right" *ngIf="appointments">
                                        <pagination-controls (pageChange)="pageChange($event)" class="my-pagination mt-2 pagination-server">
                                        </pagination-controls>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


    </div>
</div>



<ng-template #addLogSampleModal let-modal>
    <div class="row">
        <div class="col-lg-12 mb-3">


            
            <div class="card-header col-lg-12 heading_n_button_box header-dashboard-button-2">
                <h3>Log Sample</h3>
                <button class="close-button" (click)="modal.close('Save click')"><i class="fas fa-times"></i></button>
            </div>

            <div class="card-body p-4">
                <!-- <form [formGroup]="searchAppointmentForm" (ngSubmit)="onSearchAppointment(searchAppointmentForm.value)">

                    <div class="row">
                        <div class="col-md-8 offset-md-1">
                            <div class="form-group row">

                                <label for="appointment_id" class="col-md-4 col-form-label">Enter Appointment ID</label>
                                <div class="col-md-8">
                                    <input type="text" class="form-control"  formControlName="appointment_id"
                                        name="appointment_id" placeholder="Appoinment ID"
                                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; searchAppointmentForm.controls.appointment_id.errors }">


                                    <div *ngIf="submitted &amp;&amp; searchAppointmentForm.controls.appointment_id.errors"
                                        class="form-text text-danger">
                                        <div *ngIf="searchAppointmentForm.controls.appointment_id.errors.required">
                                            Appointment ID is required</div>
                                    </div>


                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-5 offset-md-7">
                                    <button type="submit" class="btn btn-secondary  theme-btn-2 dropdown-toggle-no">Search</button>
                                </div>
                            </div>

                        </div>

                    </div>

                </form> -->

            </div>
        </div>
    </div>
</ng-template>

<ng-template #viewLogSampleFormModal let-modal>

    <div class="row">
        <div class="col-lg-12 mb-3">


            <div class="card-header col-lg-12 header-dashboard-button-2">

                <h3>Sample Log</h3>
                <button class="close-button" (click)="modal.close('Save click')"><i class="fas fa-times"></i></button>
           
            </div>

            <div class="card-body p-4">
                <form [formGroup]="logSampleForm" (ngSubmit)="onSubmitLogSample(logSampleForm.value)">

                    <div class="row">
                        <div class="col-md-8 offset-md-1">


                            <div class="form-group row">
                                <label for="appointment_id" class="col-md-4 col-form-label">Passenger's Name:</label>
                                <div class="col-md-8">
                                    <input type="text" class="form-control" disabled formControlName="passengerName" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="sampleCollectionVia" class="col-md-4 col-form-label">Sample collection via:
                                </label>
                                <div class="col-md-8">

                                    <select type="text" class="form-control" formControlName="sampleCollectionVia"
                                        name="sampleCollectionVia"
                                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; logSampleForm.controls.sampleCollectionVia.errors }">
                                        <option value="" >Select Sample Via</option>
                                        <option value="Nose">Nose</option>
                                        <option value="Throat">Throat</option>
                                    </select>

                                    <div *ngIf="submitted &amp;&amp; logSampleForm.controls.sampleCollectionVia.errors"
                                        class="form-text text-danger">
                                        <div *ngIf="logSampleForm.controls.sampleCollectionVia.errors.required">
                                            Sample collection via is required</div>
                                    </div>

                                </div>
                            </div>
                            <!-- TODO: Get specimen type from API -->
                            <div class="form-group row">
                                <label for="specimenType" class="col-md-4 col-form-label">Specimen Type: </label>
                                <div class="col-md-8">

                                    <select type="text" class="form-control" formControlName="specimenType"
                                        name="specimenType"
                                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; logSampleForm.controls.specimenType.errors }">
                                        <option value="" >Select Specimen Type</option>
                                        <option value="Specimen 1">Specimen 1</option>
                                        <option value="Specimen 2">Specimen 2</option>
                                    </select>

                                    <div *ngIf="submitted &amp;&amp; logSampleForm.controls.specimenType.errors"
                                        class="form-text text-danger">
                                        <div *ngIf="logSampleForm.controls.specimenType.errors.required">
                                            Specimen type is required</div>
                                    </div>

                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="testAttendant" class="col-md-4 col-form-label">Test Attendant:</label>
                                <div class="col-md-8">
                                    <input type="text" class="form-control"  formControlName="testAttendant"
                                        name="testAttendant"
                                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; logSampleForm.controls.testAttendant.errors }" />

                                    <div *ngIf="submitted &amp;&amp; logSampleForm.controls.testAttendant.errors"
                                        class="form-text text-danger">
                                        <div *ngIf="logSampleForm.controls.testAttendant.errors.required">
                                            Test attendant is required</div>
                                    </div>

                                </div>
                            </div>


                            <div class="form-group row">
                                <div class="col-md-5 offset-md-7">
                                    <button type="submit" class="btn btn-primary theme-btn">Log Sample</button>
                                </div>
                            </div>

                        </div>

                    </div>

                </form>

            </div>
        </div>
    </div>

</ng-template>

<ng-template #viewStatusModal let-modal>

    

    <div class="card pb-5">

        <div class="">

           
            <div class="card-header heading_n_button_box header-dashboard-button-2 mb-3">
                <h3>Log Sample</h3>
                <button class="close-button" (click)="modal.close('Save click')"><i class="fas fa-times"></i></button>
            </div>  


            <div class="row">

                <div class="col-md-6 mx-auto text-center">

                    <div *ngIf="!status">
                        <!-- <h5 class="text-danger mb-3 mt-3">Payment has not been done for this test</h5> -->
                    </div>
                    <div *ngIf="status">
                        <h5 class="text-success mb-5">COVID-19 #{{appoint_id}} has logged successfully</h5>
                    </div>

                    <!-- <button type="button" *ngIf="!status" class="btn btn-secondary theme-btn-2 dropdown-toggle-no"
                        (click)="makePayment(viewMakePaymentModal)">Make Payment</button> -->

                    <button type="button" class="btn btn-secondary ml-3" [ngClass]="{ 'ml-5 mr-4': status }"
                        (click)="nextPassenger()">Next Passenger</button>

                </div>

            </div>

        </div>
    </div>
</ng-template>

<ng-template #viewMakePaymentModal let-modal>

    <div class="row">
        <div class="col-lg-12 mb-3">


            <div class="card-header col-lg-12 heading_n_button_box header-dashboard-button-2">
                <h3>Make Payment</h3>
                <button class="close-button" (click)="modal.close('Save click')"><i class="fas fa-times"></i></button>
            </div>

            <div class="card-body p-4">

                <!-- START -->

                <div class="container">
                    <div class="row">
                        <div class="col-md-6 offset-md-3">
                            <h3>COVID-19 Testing Invoice</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md">
                            <p>
                                <span> Name of Passenger: </span>
                                <span>Amaka Jones</span>
                            </p>
                            <p>
                                <span> Passport Number: </span>
                                <span>A10935467</span>
                            </p>
                        </div>
                        <div class="col-md">
                            <p>
                                <span> Scheduled Date: </span>
                                <span>11th of Feb, 2021</span>
                            </p>
                            <p>
                                <span> Scheduled Time: </span>
                                <span>11:00 AM</span>
                            </p>
                        </div>
                    </div>

                    <!-- Table -->
                    <div class="row">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Description</th>
                                    <th scope="col">Unit Price</th>
                                    <th scope="col">Qty (People)</th>
                                    <th scope="col">Total Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">COVID-19 Test at clinic center</th>
                                    <td>CFA 479</td>
                                    <td>1</td>
                                    <td>CFA 479</td>
                                </tr>
                                <tr>
                                    <th colspan="2"></th>
                                    <th scope="row">Sum Total</th>
                                    <th scope="row">CFA 479</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Table - End -->

                    <div class="row">
                        <div class="col-md-6 offset-md-6">
                            <button type="submit" class="btn btn-primary">Pay</button>
                        </div>
                    </div>


                </div>


                <!-- END -->


            </div>
        </div>
    </div>

</ng-template>

<ng-template #sampleModal let-modal>
    <div class="row">
        <div class="col-lg-12 mb-3 col-md-12 col-sm-12">



            <div class="card-header col-lg-12 heading_n_button_box header-dashboard-button-2">
                <h3>Single Appointment</h3>
                <button class="close-button" (click)="modal.close('Save click')"><i class="fas fa-times"></i></button>
            </div>

            <div class="card-body p-4">
                <form [formGroup]="singleAppointmentForm">

                    <div class="row">
                        <div class="col-lg-8 offset-lg-2 col-md-12 col-sm-12">
                            <div class="form-group row">

                                <label for="appointmenId" class="col-md-4 col-form-label">Appointment ID</label>
                                <div class="col-md-8">
                                    
                                    <input type="text" disabled class="form-control" formControlName="appointmentId"
                                        name="appointmentId">

                                </div>
                            </div>
                            <div class="form-group row">

                                <label for="fullname" class="col-md-4 col-form-label">Full name</label>
                                <div class="col-md-8">
                                    <input type="text" disabled class="form-control" formControlName="fullname" name="">

                                </div>
                            </div>
                            <div class="form-group row">

                                <label for="phone" class="col-md-4 col-form-label">Phone number</label>
                                <div class="col-md-8">
                                    <input type="text" disabled class="form-control" formControlName="phone" name="">

                                </div>
                            </div>
                            <div class="form-group row">

                                <label for="traveller" class="col-md-4 col-form-label">Travel type</label>
                                <div class="col-md-8">
                                    <input type="text" disabled class="form-control" formControlName="traveller" name="">

                                </div>
                            </div>
                            <div class="form-group row">
                            
                                <label for="passportNumber" class="col-md-4 col-form-label">Passport Number</label>
                                <div class="col-md-8">
                                    <input type="text" disabled class="form-control" formControlName="passportNumber" name="">
                            
                                </div>
                            </div>
                            <div class="form-group row">

                                <label for="date" class="col-md-4 col-form-label">Collection Date</label>
                                <div class="col-md-8">
                                    <input type="text" disabled class="form-control" formControlName="date" name="">

                                </div>
                            </div>
                            <div class="form-group row">

                                <label for="status" class="col-md-4 col-form-label">Payment Status</label>
                                <div class="col-md-8">
                                    <input type="text" disabled class="form-control" formControlName="status" name="">

                                </div>
                            </div>


                        </div>

                    </div>

                </form>

            </div>
        </div>
    </div>
</ng-template>
<app-footer-dashboard></app-footer-dashboard>